var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Topic2Modal',{ref:"topicModal"}),(_vm.topics && _vm.topics.length == 0)?_c('div',[_vm._v("You don't have any evaluated topics in this project yet.")]):_vm._e(),_c('svg',{attrs:{"id":"radar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }